import React, { useCallback } from 'react';

import { SiteConfigManager } from '@atlas/core';
import { clientProfileRoutes, COMPONENT_TYPES } from '@atlas/routing';
import { Button } from '@atlas/ui';

import history from 'components/MainRouter/history';

const PartialVerificationButton = ({ onClick }) => {
  const clientProfilePath = SiteConfigManager.getComponentPath(COMPONENT_TYPES.CLIENT_PROFILE);

  const processVerification = useCallback(() => {
    onClick?.();
    history.push(`${clientProfilePath}/${clientProfileRoutes.verification}`);
  }, [clientProfilePath, onClick]);

  return (
    <Button
      className="kyc-verification__button"
      label="go_to_kyc"
      onClick={processVerification}
      size="big"
      type="primary"
    />
  );
};

export default PartialVerificationButton;
